/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";

import { ApplicationReducer, ApplicationState, KeyType, UserReducer } from "../../../data/interfaces";

import ApiKey from "./Apikey";
import OauthKey from "./Oauth";
import { PATH_SEPARATOR } from "../../../data/constants";

interface ProductionKeyProps {
    applicationReducer: ApplicationReducer
    userReducer: UserReducer
}

function AppProductionKeys(props: ProductionKeyProps) {
    const applicationReducer = props.applicationReducer;
    const appList = applicationReducer?.applications?.list;
    const application = appList?.length > 0 ? appList[0] : undefined;
    const applicationId = application ? application.applicationId : ':applicationId';
    const { selectedOrg } = props.userReducer;
    const selectedOrgHandleName = selectedOrg.handle;

    return (
        <React.Fragment>
            <Switch>
                <Route exact path={
                    PATH_SEPARATOR + selectedOrgHandleName +'/applications/' + applicationId + '/credentials/production'
                }>
                    <OauthKey keyType={KeyType.PRODUCTION} />
                </Route>
                <Route exact={true} path={
                    PATH_SEPARATOR + selectedOrgHandleName + '/applications/' + applicationId + '/credentials/production/oauth'
                }>
                    <OauthKey keyType={KeyType.PRODUCTION} />
                </Route>
                <Route exact path={
                    PATH_SEPARATOR + selectedOrgHandleName +'/applications/' + applicationId + '/credentials/sandbox'
                }>
                    <OauthKey keyType={KeyType.SANDBOX} />
                </Route>
                <Route exact={true} path={
                    PATH_SEPARATOR + selectedOrgHandleName + '/applications/' + applicationId + '/credentials/sandbox/oauth'
                }>
                    <OauthKey keyType={KeyType.SANDBOX} />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        applicationReducer: state.applicationReducer,
        userReducer: state.userReducer
    }
};

export default connect(mapStateToProps)(AppProductionKeys);
